//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'coupon-item',
  props: {
    coupon: Object,     // 优惠券数据
    isChecked: Boolean, // 是否被选中
  },
}



// WEBPACK FOOTER //
// ./src/components/Coupon/CouponItem.vue